import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { HotelImageState } from '../../../../types/zitoneoServicesTypes';
import ImageItemView from './ImageItemView';

interface ImageItemProps {
    image: HotelImageState;
    file?: File | null;
    showCategory: boolean;
    onUpdate: (
        imageId: string,
        changes: Partial<
            Pick<
                HotelImageState,
                'Caption' | 'Feature' | 'Published' | 'Deleted'
            >
        >
    ) => void;
}

const ImageItem = ({ image, file, showCategory, onUpdate }: ImageItemProps) => {
    const translate = useTranslate();
    const [previewUrl, setPreviewUrl] = useState('');

    useEffect(() => {
        let localUrl = '';
        if (file) {
            localUrl = URL.createObjectURL(file);
        }
        setPreviewUrl(localUrl);
        return () => {
            if (localUrl) {
                URL.revokeObjectURL(localUrl);
            }
        };
    }, [file]);

    return (
        <ImageItemView
            src={previewUrl || image.Url}
            caption={image.Caption || ''}
            category={
                showCategory && image.Category
                    ? image.CategoryKey === 'BEDROOM'
                        ? translate('room')
                        : image.Category
                    : undefined
            }
            feature={image.Feature}
            published={image.Published}
            onCaptionChange={Caption => onUpdate(image.Id, { Caption })}
            onFeatureChange={Feature => onUpdate(image.Id, { Feature })}
            onPublishedChange={Published => onUpdate(image.Id, { Published })}
            onDelete={() => onUpdate(image.Id, { Deleted: true })}
        />
    );
};

export default ImageItem;
